import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { BasicModal } from '../common/modals/BasicModal';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import { TransactionScreenDataGrid } from './TransactionScreenDataGrid';
import BrowserUtils from '../../utils/BrowserUtils';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import SpendingsStore from '../../stores/SpendingsStore';

function Loader() {
  return (
    SpendingsStore.getLoader() && (
      <div className="transaction-loader">Loading</div>
    )
  );
}

function totalDaysLeft() {
  return moment().endOf('month').diff(moment(), 'days');
}

function loadSpendingAction(key) {
  SpendingsActionCreator.getAccountsList();
  SpendingsActionCreator.getBudgetConnection();
  SpendingsActionCreator.getTagListConnection();
  SpendingsActionCreator.getBudgetPreferencesConnection();
  SpendingsActionCreator.getSpendingPageWithKey(key);
}

class TransactionScreen extends Component {
  constructor(props) {
    super(props);

    this.goBack = this.goBack.bind(this);
    this.onHide = this.onHide.bind(this);
    this.onRowClick = this.onRowClick.bind(this);

    // previously executed in componentWillMount()...
    BrowserUtils.isMobileView() && SiteHeaderActionCreator.hideHeaderFlag(true);

    this.state = {
      isModal: false,
      rowCustomClass: '',
      rowClickIndex: -1,
    };
  }

  goBack() {
    loadSpendingAction(this.props.loadSpendingPage);
  }

  onHide() {
    this.setState(function () {
      return { isModal: false };
    });
  }

  onRowClick(row, rowClickIndex, columnName) {
    this.setState(function () {
      return {
        rowCustomClass:
          rowClickIndex !== this.state.rowClickIndex ||
          this.state.rowCustomClass !== 'row-open'
            ? 'row-open'
            : '',
        rowClickIndex,
        isModal: columnName === 'account' && row.inProgress,
      };
    });
  }

  render() {
    const { transactionsTagName, content } = this.props;

    const isMobileView = BrowserUtils.isMobileView();

    return (
      <div className={isMobileView ? 'spending main-container noheader' : ''}>
        {isMobileView ? (
          <div className="spendings-landings">
            <div className="transactions-screen">
              <div className="row no-gutters header-row">
                <div className="col-xs-6">
                  <button
                    className="page-back"
                    id="0"
                    type="button"
                    onClick={this._goBack}
                  >
                    <span className="icon icon-page-back" />
                    {content.back}
                  </button>
                </div>
                <div className="col-xs-12 text-center">
                  <h5>{transactionsTagName}</h5>
                </div>
              </div>
              <div className="calendar-row budget-calendar">
                <section className="full-row text-center">
                  <h5>
                    <span className="icon icon-calendar" />
                    <b>{totalDaysLeft()}</b> {content.spendingDaysLeftText}
                  </h5>
                </section>
              </div>
              <div className="scroll-wrapper">
                <TransactionScreenDataGrid
                  content={content}
                  onRowClick={this.onRowClick}
                  rowCustomClass={this.state.rowCustomClass}
                  rowClickIndex={this.state.rowClickIndex}
                />
                <Loader />
              </div>
            </div>
          </div>
        ) : (
          <div className="main-container edit-transaction">
            <div className="row no-gutters header-row">
              <div className="header-content">
                <div className="col-xs-2 text-left">
                  <button className="page-back" onClick={this.goBack}>
                    <span className="icon icon-page-back" />
                    {content.back}
                  </button>
                </div>
                <div className="col-xs-8 text-center">
                  <h3>
                    {`${content.spendingTransitionHeaderText1} ${transactionsTagName} ${content.spendingTransitionHeaderText2}`}
                  </h3>
                </div>
                <div className="col-xs-2 text-right" />
              </div>
            </div>
            <div className="spendings-list">
              <TransactionScreenDataGrid
                content={content}
                onRowClick={this.onRowClick}
                rowCustomClass={this.state.rowCustomClass}
                rowClickIndex={this.state.rowClickIndex}
              />
              <Loader />
            </div>
            {this.state.isModal === true && (
              <BasicModal keyboard={false} backdrop="static">
                <div className="modal_content">
                  <h3>{content.spendingTransitionInProgressHeaderText}</h3>
                  <p>{content.spendingTransitionInProgressMessage}</p>
                </div>
                <div className="modal_footer">
                  <button className="btn btn-link" onClick={this.onHide}>
                    {content.spendingOkButtonText}
                  </button>
                </div>
              </BasicModal>
            )}
          </div>
        )}
      </div>
    );
  }
}

TransactionScreen.propTypes = {
  content: PropTypes.object,
  transactionsTagName: PropTypes.string,
  transactionPageSize: PropTypes.number,
  loadSpendingPage: PropTypes.number,
};

export { TransactionScreen };
